document.addEventListener('DOMContentLoaded', function() {
    const lightbox = GLightbox();

    document.querySelectorAll('[data-video-trigger]').forEach((trigger) => {
        const playVideo = () => {
            const mediaWrapper = trigger.closest('.about--img, .award--img');
            const embed = mediaWrapper?.querySelector('[data-video-embed]');
            const iframe = embed?.querySelector('iframe');

            if (!embed || !iframe) {
                return;
            }

            const videoUrl = trigger.dataset.videoEmbedUrl;

            if (videoUrl) {
                iframe.setAttribute('src', videoUrl);
            }

            embed.hidden = false;
            mediaWrapper?.classList.add('is-playing');
        };

        trigger.addEventListener('click', playVideo);
        trigger.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                playVideo();
            }
        });
    });

    setTimelineYearLabels();

    function setTimelineYearLabels() {
        const timelineSlides = document.querySelectorAll('.swiper-timeline .swiper-slide');
        const controllerSlides = document.querySelectorAll('.swiper-timeline-controller .swiper-slide');

        timelineSlides.forEach((slide, i) => {
            const label = slide.getAttribute('data-title');
            const yearElement = controllerSlides[i]?.querySelector('.year');

            if (label && yearElement) {
                yearElement.textContent = label;
            }
        });

    }

    const animateDivider = () => {
        const activeDivider = document.querySelector('.swiper-timeline .swiper-slide-active .divider');

        document.querySelectorAll('.swiper-timeline .divider').forEach((divider) => {
            divider.classList.remove('is-animating');
        });

        requestAnimationFrame(() => {
            activeDivider?.classList.add('is-animating');
        });
    };

    // swipers 
    const swiperTimeline = new Swiper('.swiper-timeline', {
        slidesPerView: 1,
        speed: 1000,
        direction: 'vertical',
        allowTouchMove: false,
        // fade: true,
    })

    const swiperTimelineController = new Swiper('.swiper-timeline-controller', {
        slidesPerView: 5,
        centeredSlides: true,
        speed: 1000,
        direction: 'vertical',
        // fade: true,
        
        navigation: {
            prevEl: '.swiper-timeline-controller .swiper-button-prev',
            nextEl: '.swiper-timeline-controller .swiper-button-next'
        },
        thumbs: {
            swiper: swiperTimeline
        },
        breakpoints: {
            992: {
                // slidesPerView: 6,
                centerInsufficientSlides: false,
                autoHeight: false,
            }
        }
    })

    swiperTimeline.on('slideChangeTransitionEnd', animateDivider);
    swiperTimelineController.on('slideChangeTransitionEnd', animateDivider);
    animateDivider();

    // No mobile o conteúdo do slide (título de duas linhas + texto) passa da
    // altura fixa do CSS e é cortado. Como o swiper é vertical, ele precisa de
    // altura definida: mede o slide mais alto e aplica essa altura.
    const timelineEl = document.querySelector('.swiper-timeline');

    function fitTimelineHeight() {
        if (!timelineEl) {
            return;
        }

        // desktop mantém a altura fixa do CSS
        if (window.innerWidth >= 992) {
            timelineEl.style.height = '';
            swiperTimeline.update();
            return;
        }

        let tallest = 0;

        timelineEl.querySelectorAll('.swiper-slide').forEach((slide) => {
            const wrapper = slide.querySelector('.wrapper');

            if (!wrapper) {
                return;
            }

            const slideTop = slide.getBoundingClientRect().top;
            const wrapperBottom = wrapper.getBoundingClientRect().bottom;

            tallest = Math.max(tallest, wrapperBottom - slideTop);
        });

        if (tallest) {
            timelineEl.style.height = `${Math.ceil(tallest)}px`;
            swiperTimeline.update();
        }
    }

    fitTimelineHeight();

    // as fontes mudam a quebra de linha dos títulos
    if (document.fonts) {
        document.fonts.ready.then(fitTimelineHeight);
    }

    let timelineResizeTimeout;

    window.addEventListener('resize', () => {
        window.clearTimeout(timelineResizeTimeout);
        timelineResizeTimeout = window.setTimeout(fitTimelineHeight, 200);
    });

    // galeria: accordion no desktop (>= 992px) e swiper no mobile
    const desktopQuery = window.matchMedia('(min-width: 992px)');
    const galleryAccordion = initGalleryAccordion(document.querySelector('[data-gallery-accordion]'));

    // com poucas fotos o loop repete a mesma imagem nas laterais
    const gallerySlidesCount = document.querySelectorAll('.swiper-gallery .swiper-slide').length;

    const swiperGallery = new Swiper('.swiper-gallery', {
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 16,
        speed: 1000,
        loop: gallerySlidesCount >= 4,
        // sem loop as setas voltam para a primeira/última foto
        rewind: gallerySlidesCount < 4,
        effect: 'coverflow',
        
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 200,
            modifier: 1,
            slideShadows: false
        },
    });

    // as setas são as mesmas nos dois layouts, então não usam o navigation do
    // swiper (ele desabilitava as setas do desktop junto com as do mobile)
    document.querySelector('.gallery .arrow-left')?.addEventListener('click', () => {
        if (desktopQuery.matches) {
            galleryAccordion?.prev();
        } else {
            swiperGallery.slidePrev();
        }
    });

    document.querySelector('.gallery .arrow-right')?.addEventListener('click', () => {
        if (desktopQuery.matches) {
            galleryAccordion?.next();
        } else {
            swiperGallery.slideNext();
        }
    });

    // A foto ativa fica no centro com até duas de cada lado e as setas giram
    // por todas as fotos cadastradas. Cada foto é posicionada com transform e
    // recortada com clip-path: como todas animam juntas com a mesma curva, o
    // espaço entre elas se mantém durante toda a transição.
    function initGalleryAccordion(accordion) {
        const photos = accordion ? Array.from(accordion.querySelectorAll('.gallery-accordion__slide')) : [];

        if (!photos.length) {
            return null;
        }

        const total = photos.length;
        // quantas fotos aparecem antes e depois da ativa
        const before = Math.min(2, Math.floor((total - 1) / 2));
        const after = Math.min(2, Math.ceil((total - 1) / 2));

        // abre só as fotos originais, sem as cópias criadas abaixo
        const lightbox = GLightbox({
            elements: photos.map((slide) => ({
                href: slide.querySelector(':scope > img').src,
                type: 'image',
            })),
        });

        // com poucas fotos duplica a lista (como o loop do swiper) para sempre
        // ter fotos escondidas dos dois lados, prontas para entrar
        const copies = total > 1 ? Math.ceil(9 / total) : 1;

        for (let copy = 1; copy < copies; copy++) {
            photos.forEach((slide) => {
                const clone = slide.cloneNode(true);

                clone.setAttribute('aria-hidden', 'true');
                accordion.appendChild(clone);
            });
        }

        const slides = Array.from(accordion.querySelectorAll('.gallery-accordion__slide'));
        // posição aplicada em cada foto (null = escondida com display none)
        const slots = slides.map(() => null);
        let active = 0;
        let sizes = null;
        let settleTimeout;
        let isNear = false;

        const isVisible = (slot) => slot !== null && slot >= -before && slot <= after;
        // posição invisível (largura 0) logo depois da última foto de cada lado
        const waitingSlot = (side) => (side < 0 ? -before - 1 : after + 1);
        const isWaiting = (slot) => slot === waitingSlot(-1) || slot === waitingSlot(1);

        // distância até a foto ativa, contando pelo lado mais curto
        function offsetOf(index) {
            const offset = (index - active + slides.length) % slides.length;

            return offset > slides.length / 2 ? offset - slides.length : offset;
        }

        function slotWidth(slot) {
            if (!isVisible(slot)) {
                return 0;
            }

            return slot === 0 ? sizes.activeWidth : sizes.width;
        }

        function slotHeight(slot) {
            if (slot === 0) {
                return sizes.height;
            }

            return Math.abs(slot) === 1 ? sizes.adjacentHeight : sizes.farHeight;
        }

        // centro da posição em relação ao centro da foto ativa
        function slotCenter(slot) {
            const side = Math.sign(slot);
            let center = 0;

            for (let i = 1; i <= Math.abs(slot); i++) {
                center += slotWidth((i - 1) * side) / 2 + sizes.gap + slotWidth(i * side) / 2;
            }

            return center * side;
        }

        function measure() {
            const styles = getComputedStyle(accordion);
            const size = (name) => parseFloat(styles.getPropertyValue(name));
            const gaps = (before + after) * size('--slide-gap');
            const widths = size('--slide-active-width') + (before + after) * size('--slide-width');
            // em telas menores as larguras diminuem para caber no container
            const scale = Math.min(1, (accordion.clientWidth - gaps) / widths);

            sizes = {
                gap: size('--slide-gap'),
                radius: size('--slide-radius'),
                width: size('--slide-width') * scale,
                activeWidth: size('--slide-active-width') * scale,
                height: accordion.clientHeight,
                adjacentHeight: size('--slide-adjacent-height'),
                farHeight: size('--slide-height'),
            };

            // centraliza a fileira (com número par de fotos ela fica assimétrica)
            const rowStart = slotCenter(-before) - slotWidth(-before) / 2;
            const rowEnd = slotCenter(after) + slotWidth(after) / 2;

            sizes.shift = (rowStart + rowEnd) / 2;
        }

        function place(index, slot) {
            const slide = slides[index];
            const insetX = (sizes.activeWidth - slotWidth(slot)) / 2;
            const insetY = (sizes.height - slotHeight(slot)) / 2;

            slots[index] = slot;
            slide.hidden = false;
            slide.classList.toggle('is-active', slot === 0);
            slide.style.opacity = isVisible(slot) ? 1 : 0;
            slide.style.transform = `translateX(${slotCenter(slot) - sizes.shift - sizes.activeWidth / 2}px)`;
            slide.style.clipPath = `inset(${insetY}px ${insetX}px round ${sizes.radius}px)`;
        }

        function hide(index) {
            slots[index] = null;
            slides[index].hidden = true;
            slides[index].classList.remove('is-active');
        }

        // posiciona sem animar (fotos invisíveis ou mudança de tamanho)
        function jump(list) {
            if (!list.length) {
                return;
            }

            list.forEach(([index, slot]) => {
                slides[index].style.transition = 'none';
                place(index, slot);
            });

            // aplica as posições antes de devolver a transição
            accordion.offsetHeight;

            list.forEach(([index]) => {
                slides[index].style.transition = '';
            });

            preload();
        }

        // as fotos esperando para entrar ficam recortadas (largura 0) e o lazy
        // loading do navegador não as carrega; com a galeria perto da tela,
        // todas as posicionadas carregam na hora para não entrarem em branco
        function preload() {
            if (!isNear) {
                return;
            }

            slides.forEach((slide) => {
                if (!slide.hidden) {
                    slide.querySelector(':scope > img').loading = 'eager';
                }
            });
        }

        function layout() {
            // escondido no mobile
            if (!accordion.clientWidth) {
                return;
            }

            measure();
            window.clearTimeout(settleTimeout);

            const list = [];

            slides.forEach((slide, index) => {
                const offset = offsetOf(index);

                slide.style.width = `${sizes.activeWidth}px`;

                if (isVisible(offset) || isWaiting(offset)) {
                    list.push([index, offset]);
                } else {
                    hide(index);
                }
            });

            jump(list);
        }

        function go(delta) {
            if (slides.length < 2) {
                return;
            }

            active = (active + delta + slides.length) % slides.length;

            if (!sizes) {
                return;
            }

            const entering = [];
            const moving = [];

            slides.forEach((slide, index) => {
                const offset = offsetOf(index);
                const slot = slots[index];

                if (isVisible(offset)) {
                    // entra pelo lado de onde veio, partindo da posição invisível
                    const from = waitingSlot(Math.sign(offset + delta));

                    if (!isVisible(slot) && slot !== from) {
                        entering.push([index, from]);
                    }

                    moving.push([index, offset]);
                } else if (isVisible(slot)) {
                    // sai pelo lado em que está
                    moving.push([index, waitingSlot(Math.sign(slot) || -delta)]);
                } else if (slot === null && isWaiting(offset)) {
                    // próxima a entrar: já fica no lugar para carregar a imagem
                    entering.push([index, offset]);
                }
            });

            jump(entering);
            moving.forEach(([index, slot]) => place(index, slot));

            window.clearTimeout(settleTimeout);
            settleTimeout = window.setTimeout(settle, 850); // transição de .8s do about.scss
        }

        // depois da animação esconde as fotos que saíram e deixa as próximas
        // de cada lado no lugar certo para entrar
        function settle() {
            const list = [];

            slides.forEach((slide, index) => {
                const offset = offsetOf(index);

                if (isWaiting(offset)) {
                    if (slots[index] !== offset) {
                        list.push([index, offset]);
                    }
                } else if (!isVisible(offset) && slots[index] !== null) {
                    hide(index);
                }
            });

            jump(list);
        }

        // foto lateral vira a ativa; a ativa abre o lightbox
        accordion.addEventListener('click', (event) => {
            const index = slides.indexOf(event.target.closest('.gallery-accordion__slide'));

            if (index < 0) {
                return;
            }

            const offset = offsetOf(index);

            if (offset === 0) {
                lightbox.openAt(index % total);
            } else if (isVisible(offset)) {
                go(offset);
            }
        });

        layout();
        new ResizeObserver(layout).observe(accordion);

        new IntersectionObserver((entries, observer) => {
            if (entries.some((entry) => entry.isIntersecting)) {
                isNear = true;
                observer.disconnect();
                preload();
            }
        }, { rootMargin: '600px 0px' }).observe(accordion);

        return {
            prev: () => go(-1),
            next: () => go(1),
        };
    }

    const swiperTech = new Swiper('.swiper-tech', {
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        spaceBetween: 12,

        pagination: {
            el: '.swiper-tech .swiper-pagination',
            clickable: true
        },
    })
})
